<template>
  <div>
    <div class="mb-1">
      <div class="btn-group btn-group-toggle" data-toggle="buttons">
        <label v-bind:class="{'btn btn-outline-primary': true, 'active': +action === 1}">
          <input type="radio" name="options" v-model="action" value="1"> Перезвон
        </label>
        <label v-bind:class="{'btn btn-outline-primary': true, 'active': +action === 2}">
          <input type="radio" v-model="action" value="2"> Уведомление
        </label>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8">
        <div class="form-group mb-0">
          Сообщение для уведомления
          <input type="text" placeholder="Текст уведомления" class="form-control" v-model="message">
        </div>
      </div>
      <div class="col-md-4 flex">
        <div class="form-group mb-0">
          Время активации уведомления
          <DateTimeSelect
            ref="selectedDateTime"
            customShortCutsDates="orderNotifications"
            :disabled="true"
          />
        </div>
        <div class="ml-2">
          <LoadingButton
            title="Создать уведомление"
            className="btn btn-outline-success save_btn"
            :loading="loading"
            :color="$constants.LOADING_COLOR"
            :onClick="() => saveNotification()"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from '@/api'
import DateTimeSelect from '@/components/dateSelect/DateTimeSelect'
import LoadingButton from '@/components/buttons/LoadingButton'

export default {
  components: {
    DateTimeSelect,
    LoadingButton,
  },
  props: ['orderId'],
  data() {
    return {
      loading: false,
      action: 1,
      message: null
    }
  },
  methods: {
    async saveNotification() {
      if (+this.action !== 1 && !this.message) {
        toastr['warning']('Укажите текст для уведомления')
        return
      }
      const selectedDate = this.$refs.selectedDateTime.formatDate;
      if (!selectedDate) {
        toastr['warning']('Укажите время активации уведомления')
        return
      }
      const sDate = new Date(selectedDate)
      const tDate = new Date()
      console.log(sDate, tDate, sDate > tDate, sDate < tDate)
      if (sDate < tDate) {
        toastr['warning']('Недопустимое значение времени уведомления')
        return
      }
      this.loading = true;
      const {data} = await api.post('/notifications/new', {
        orderId: this.orderId,
        action: this.action,
        message: this.message,
        date: selectedDate
      })
      if (!data.success) {
        toastr['warning'](data.message || 'Недопустимое значение времени уведомления', 'Ошибка')
      } else {

      }
      this.loading = false;
    }
  }
}
</script>

<style scoped>
.save_btn {
  position: absolute;
  bottom: 0;
}
</style>
